import React from 'react';
import Cta from 'marketing-website/components/modules/Cta/CtaDefault';

export default function FooterCta() {
  const buttons = [
    {
      link: '/enterprise',
      text: 'Discover Marvel Enterprise',
      styles: { shape: 'rounded', size: 'large', minWidth: 230 },
    },
  ];
  return (
    <Cta
      maxWidth={660}
      title="Work in a large team? Find out more about Marvel Enterprise."
      buttons={buttons}
    />
  );
}



// WEBPACK FOOTER //
// ./src/pages/why-marvel/FooterCta.js